export default "__VITE_ASSET__ZRp_LJOf__"